import React from 'react';

import {getFieldOptions} from 'registry/field/FieldTableOptionGetters';
import {StorableSchema} from 'samples/storables/StorableSchemaConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {SchemaInterface} from 'schemas/SchemaConstants';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';

import {TagSchemaSummaryGraphQL} from '../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaSummaryGraphQL';
import FieldTableRow from './FieldTableRow';

export interface StorableFieldTableRowProps {
  schemaFieldSelectors: Array<SchemaFieldSelector>;
  ownerUrlId: string;
  registryId: string;
  id: string;
  initialField: SchemaField;
  onCancel: (id: string) => void;
  onEdit: (id: string) => void;
  requestChange: (id: string, fieldWithChanges: SchemaField) => void;
  requestRemove: (id: string) => void;
  tagSchemas?: Array<TagSchemaSummaryGraphQL>;
  storableSchemas?: Array<StorableSchema>;
  schemaInterfaces: Array<SchemaInterface>;
  shouldShowDescription?: boolean;
}

export default function StorableFieldTableRow(props: StorableFieldTableRowProps): JSX.Element {
  return (
    <FieldTableRow
      availableFieldOptions={getFieldOptions({
        initialField: props.initialField,
        schemaFieldSelectors: props.schemaFieldSelectors,
        storableSchemas: props.storableSchemas ?? [],
        tagSchemas: props.tagSchemas ?? [],
        schemaInterfaces: props.schemaInterfaces,
        includeJSONField: false,
        includeAssayLinks: false,
        includeBatchLinks: false,
        includeGenericBioentityLinks: true,
        includeBooleanField: false,
        includeSnapshotField: false,
        includeSequenceLinks: false,
        includeArchivedSchemas: true,
      })}
      {...props}
      shouldShowWarehouseWarning={true}
      isUneditable={props.initialField.isUneditable}
      schemaId={null}
    />
  );
}
